import PublicApiModel from './globals/PublicApiModel';

export default class ResetPasswordModel extends PublicApiModel {
  static get path() {
    return '/backend/users/reset-password';
  }
}
